/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ThreadsControllerFindAllQueryResponse, ThreadsControllerFindAllQueryParams, ThreadsControllerFindAll401, ThreadsControllerFindAll403 } from "../../models/threadsController/ThreadsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { threadsControllerFindAll } from "../../clients/threadsService/threadsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const threadsControllerFindAllQueryKey = (params: ThreadsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/threads'
}, ...(params ? [params] : [])] as const;
export type ThreadsControllerFindAllQueryKey = ReturnType<typeof threadsControllerFindAllQueryKey>;
export function threadsControllerFindAllQueryOptions(params?: ThreadsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = threadsControllerFindAllQueryKey(params);
  return queryOptions<ThreadsControllerFindAllQueryResponse, ResponseErrorConfig<ThreadsControllerFindAll401 | ThreadsControllerFindAll403>, ThreadsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return threadsControllerFindAll(params, config);
    }
  });
}

/**
 * @description Get paginated list of threads for the current user, with optional filtering and sorting.
 * @summary List threads
 * {@link /api/v1/threads}
 */
export function useThreadsControllerFindAll<TData = ThreadsControllerFindAllQueryResponse, TQueryData = ThreadsControllerFindAllQueryResponse, TQueryKey extends QueryKey = ThreadsControllerFindAllQueryKey>(params?: ThreadsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ThreadsControllerFindAllQueryResponse, ResponseErrorConfig<ThreadsControllerFindAll401 | ThreadsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? threadsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...threadsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ThreadsControllerFindAll401 | ThreadsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}